import { Component, inject, Input } from '@angular/core';
import { EquipmentItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-tga-type-badge',
  templateUrl: './tga-type-badge.component.html',
  styleUrls: ['./tga-type-badge.component.scss']
})
export class TgaTypeBadgeComponent {
  readonly router = inject(Router);

  @Input()
  @Tracked()
  tgaType?: EquipmentItemDto;

  @Input()
  @Tracked()
  disableLink = false;
}
